<template>
  <div class="row abnormal-warn">
    <div class="col">
      <div class="row mb-3">
        <el-tabs
          tab-position="left"
          v-model="activeName"
          style="width: 100%"
          @tab-click="changeTab"
        >
          <el-tab-pane label="课程建设建议" name="first">
            <div v-if="activeName === 'first'">
              <div class="data-range mb-3">统计范围：{{ countArea }}</div>
              <div class="row">
                <div class="col">
                  <el-table
                    ref="courseSuggestion"
                    v-if="suggesstionData.length > 0"
                    class="mb-3"
                    :data="suggesstionData"
                    row-key="id"
                    default-expand-all
                    stripe=""
                  >
                    <el-table-column prop="" label="序号">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="item" label="项目"></el-table-column>
                    <el-table-column prop="suggest" label="现状与建议">
                      <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.suggest" :key="index">
                          {{ item }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <span class="operative" @click="viewAdvice(scope.row)">查看</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-else class="empty-suggesstion-box">
                    <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                    <div class="suggesstion-tips">&nbsp;&nbsp;暂无建议</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="未访问课程学生" name="second">
            <div v-if="activeName === 'second'">
              <div class="flex-between flex-align-center">
                <el-radio-group size="mini" v-model="accessRange" @change="changePeriod">
                  <el-radio-button label="1">本周</el-radio-button>
                  <el-radio-button label="2">上周</el-radio-button>
                  <el-radio-button label="3">近三十天</el-radio-button>
                  <el-radio-button label="4">从未访问</el-radio-button>
                </el-radio-group>
                <div class="data-range">统计范围：{{ countArea }}</div>
              </div>
              <div class="flex-between flex-align-center mb-2">
                <el-select
                  v-if="filterDimension == 1"
                  class="group-condition"
                  v-model="group"
                  @change="handleGroup('student')"
                >
                  <el-option value="0" label="全部小组"></el-option>
                  <el-option
                    v-for="item in groupOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-select
                  v-if="filterDimension == 2"
                  class="group-condition"
                  v-model="course"
                  @change="handleCourse('student')"
                >
                  <el-option value="0" label="全部选课"></el-option>
                  <el-option
                    v-for="item in courseOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <!-- <el-button type="primary" size="small">消息提醒</el-button> -->
              </div>
              <el-table
                ref="accessWarn"
                class="mb-3"
                v-if="accessWarnData.length > 0"
                :data="accessWarnData"
                row-key="id"
                default-expand-all
                stripe=""
              >
                <el-table-column prop="user_id" label="序号"></el-table-column>
                <el-table-column prop="firstname" label="姓名"></el-table-column>
                <el-table-column prop="username" label="学号"></el-table-column>
                <el-table-column prop="college" label="学院"></el-table-column>
              </el-table>
              <div v-else class="empty-suggesstion-box">
                <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                <div class="suggesstion-tips">&nbsp;&nbsp;暂无名单</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="作业完成异常" name="third">
            <div v-if="activeName === 'third'">
              <div class="flex-between flex-align-center mb-2">
                <div>
                  <el-button
                    type="primary"
                    class="export-btn"
                    :disabled="assignData.length == 0"
                    @click="exportTable('assign', 'assign-table')"
                  >
                    导出表格
                  </el-button>
                  <el-select
                    v-if="filterDimension == 1"
                    class="group-condition"
                    v-model="group"
                    @change="handleGroup('assign')"
                  >
                    <el-option value="0" label="全部小组"></el-option>
                    <el-option
                      v-for="item in groupOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="filterDimension == 2"
                    class="group-condition"
                    v-model="course"
                    @change="handleCourse('assign')"
                  >
                    <el-option value="0" label="全部选课"></el-option>
                    <el-option
                      v-for="item in courseOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="data-range">统计范围：{{ countArea }}</div>
              </div>
              <el-table
                ref="assignWarn"
                v-if="assignData.length > 0"
                id="assign-table"
                class="mb-3"
                :data="assignData"
                row-key="id"
                default-expand-all
                stripe=""
              >
                <el-table-column prop="username" label="学号"></el-table-column>
                <el-table-column prop="firstname" label="姓名" sortable=""></el-table-column>
                <el-table-column prop="assign" label="作业名称" sortable=""></el-table-column>
                <el-table-column prop="submit" label="提交情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.submit === 0">未提交</span>
                    <span v-else-if="scope.row.submit === 1">已提交</span>
                    <span v-else-if="scope.row.submit === 2">过期提交</span>
                  </template>
                </el-table-column>
                <el-table-column prop="grade" label="成绩情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.grade === 0">无</span>
                    <span v-else-if="scope.row.grade === 1">及格</span>
                    <span v-else-if="scope.row.grade === 2">不及格</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-suggesstion-box">
                <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                <div class="suggesstion-tips">&nbsp;&nbsp;暂无名单</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="测验完成异常" name="fourth">
            <div v-if="activeName === 'fourth'">
              <div class="flex-between flex-align-center mb-2">
                <div>
                  <el-button
                    type="primary"
                    class="export-btn"
                    :disabled="quizData.length == 0"
                    @click="exportTable('quiz', 'quiz-table')"
                  >
                    导出表格
                  </el-button>
                  <el-select
                    v-if="filterDimension == 1"
                    class="group-condition"
                    v-model="group"
                    @change="handleGroup('quiz')"
                  >
                    <el-option value="0" label="全部小组"></el-option>
                    <el-option
                      v-for="item in groupOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="filterDimension == 2"
                    class="group-condition"
                    v-model="course"
                    @change="handleCourse('quiz')"
                  >
                    <el-option value="0" label="全部选课"></el-option>
                    <el-option
                      v-for="item in courseOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="data-range">统计范围：{{ countArea }}</div>
              </div>
              <el-table
                ref="quizWarn"
                v-if="quizData.length > 0"
                id="quiz-table"
                class="mb-3"
                :data="quizData"
                row-key="id"
                default-expand-all
                stripe=""
              >
                <el-table-column prop="user_id" label="序号"></el-table-column>
                <el-table-column prop="firstname" label="姓名" sortable></el-table-column>
                <el-table-column prop="quiz" label="测验名称" sortable></el-table-column>
                <el-table-column prop="submit" label="作答情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.submit === 0">没有作答</span>
                    <span v-else-if="scope.row.submit === 1">没有提交</span>
                    <span v-else-if="scope.row.submit === 2">完成作答</span>
                    <span v-else-if="scope.row.submit === 3">提交异常（一分钟内提交）</span>
                    <span v-else-if="scope.row.submit === 4">空白卷提交</span>
                  </template>
                </el-table-column>
                <el-table-column prop="grade" label="成绩情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.grade === 0">无</span>
                    <span v-else-if="scope.row.grade === 1">及格</span>
                    <span v-else-if="scope.row.grade === 2">不及格</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-suggesstion-box">
                <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                <div class="suggesstion-tips">&nbsp;&nbsp;暂无名单</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="讨论参与异常" name="fifth">
            <div v-if="activeName === 'fifth'">
              <div class="flex-between flex-align-center mb-2">
                <div>
                  <el-button
                    type="primary"
                    class="export-btn"
                    :disabled="discussData.length == 0"
                    @click="exportTable('forum', 'forum-table')"
                  >
                    导出表格
                  </el-button>
                  <el-select
                    v-if="filterDimension == 1"
                    class="group-condition"
                    v-model="group"
                    @change="handleGroup('forum')"
                  >
                    <el-option value="0" label="全部小组"></el-option>
                    <el-option
                      v-for="item in groupOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="filterDimension == 2"
                    class="group-condition"
                    v-model="course"
                    @change="handleCourse('forum')"
                  >
                    <el-option value="0" label="全部选课"></el-option>
                    <el-option
                      v-for="item in courseOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>

                <div class="data-range">统计范围：{{ countArea }}</div>
              </div>
              <el-table
                ref="forumWarn"
                v-if="discussData.length > 0"
                id="forum-table"
                class="mb-3"
                :data="discussData"
                row-key="id"
                default-expand-all
                stripe=""
              >
                <el-table-column prop="username" label="学号"></el-table-column>
                <el-table-column prop="firstname" label="姓名"></el-table-column>
                <el-table-column prop="message" label="异常情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.message === 1">从未浏览讨论区</span>
                    <span v-else-if="scope.row.message === 2">从未参与讨论</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-suggesstion-box">
                <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                <div class="suggesstion-tips">&nbsp;&nbsp;暂无名单</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="不及格预警" name="sixth">
            <div v-if="activeName === 'sixth'">
              <div class="flex-between flex-align-center mb-2">
                <div>
                  <el-button
                    type="primary"
                    class="export-btn"
                    :disabled="notPassData.length == 0"
                    @click="exportTable('nopass', 'nopass-table')"
                  >
                    导出表格
                  </el-button>
                  <el-select
                    v-if="filterDimension == 1"
                    class="group-condition"
                    v-model="group"
                    @change="handleGroup('nopass')"
                  >
                    <el-option value="0" label="全部小组"></el-option>
                    <el-option
                      v-for="item in groupOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="filterDimension == 2"
                    class="group-condition"
                    v-model="course"
                    @change="handleCourse('nopass')"
                  >
                    <el-option value="0" label="全部选课"></el-option>
                    <el-option
                      v-for="item in courseOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="data-range">统计范围：{{ countArea }}</div>
              </div>
              <el-table
                ref="gradeWarn"
                v-if="notPassData.length > 0"
                id="nopass-table"
                class="mb-3"
                :data="notPassData"
                row-key="id"
                default-expand-all
                stripe=""
              >
                <el-table-column prop="username" label="学号"></el-table-column>
                <el-table-column prop="firstname" label="姓名"></el-table-column>
                <el-table-column prop="grade" label="成绩情况">
                  <template slot-scope="scope">
                    <span v-if="scope.row.grade === 1">不及格</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="empty-suggesstion-box">
                <img src="@/assets/images/course/pic_result_nodata.png" alt="" />
                <div class="suggesstion-tips">&nbsp;&nbsp;暂无名单</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
// import Pagination from '@/components/Pagination.vue'
import { domainName } from '@/config/setting.js'

export default {
  // components: {
  //   Pagination,
  // },
  data() {
    return {
      activeName: 'first',
      suggesstionData: [],
      accessWarnData: [],
      assignData: [],
      quizData: [],
      discussData: [],
      notPassData: [],
      // 小组选项
      group: '0',
      groupOption: [],
      // 选课选项
      course: '0',
      courseOption: [],
      accessRange: '1',
    }
  },
  computed: {
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
    filterDimension() {
      return this.$store.state.course.courseInfo.search_setting
    },
    courseId() {
      return this.$route.query.courseId
    },
  },
  // update() {
  //   // 解决el-tabs嵌套el-table时，el-table抖动问题
  //   this.$refs.courseSuggestion.doLayout()
  //   this.$refs.accessWarn.doLayout()
  //   this.$refs.assignWarn.doLayout()
  //   this.$refs.quizWarn.doLayout()
  //   this.$refs.forumWarn.doLayout()
  //   this.$refs.gradeWarn.doLayout()
  // },
  mounted() {
    this.getCourseSuggestApi()
    this.getCourseGroupApi()
    this.getCourseJoinTypeApi()
  },
  methods: {
    changeTab(tab, event) {
      console.log('tab', tab)
      console.log('tab', tab.index)
      console.log('event', event)
      switch (tab.index) {
        case '0':
          this.getCourseSuggestApi()
          break
        case '1':
          this.getAccessWarnApi()
          break
        case '2':
          this.getAssignWarnApi()
          break
        case '3':
          this.getQuizWarnApi()
          break
        case '4':
          this.getForumWarnApi()
          break
        case '5':
          this.getGradeWarnApi()
          break
      }
    },
    changePeriod(val) {
      console.log('val', val)
      this.getAccessWarnApi()
    },
    // 获取课程小组
    async getCourseGroupApi() {
      await this.$store
        .dispatch('course/getCourseGroup', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.groupOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取选课方式
    async getCourseJoinTypeApi() {
      await this.$store
        .dispatch('course/getCourseJoinType', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取课程建议
    async getCourseSuggestApi() {
      await this.$store
        .dispatch('course/getCourseSuggest', {
          course_id: Number(this.$route.query.courseId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.suggesstionData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取未访问课程学生列表
    async getAccessWarnApi() {
      await this.$store
        .dispatch('course/getAccessWarn', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course||0,
          type: Number(this.accessRange),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.accessWarnData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取作业完成异常列表
    async getAssignWarnApi() {
      await this.$store
        .dispatch('course/getAssignWarn', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course||0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.assignData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取测验完成异常列表
    async getQuizWarnApi() {
      await this.$store
        .dispatch('course/getQuizWarn', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course||0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.quizData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取讨论参与异常列表
    async getForumWarnApi() {
      await this.$store
        .dispatch('course/getForumWarn', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course||0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.discussData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取不及格预警列表
    async getGradeWarnApi() {
      await this.$store
        .dispatch('course/getGradeWarn', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course||0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.notPassData = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    handleGroup(type) {
      console.log('type:', type)
      switch (type) {
        case 'student':
          this.getAccessWarnApi()
          break
        case 'assign':
          this.getAssignWarnApi()
          break
        case 'quiz':
          this.getQuizWarnApi()
          break
        case 'forum':
          this.getForumWarnApi()
          break
        case 'nopass':
          this.getGradeWarnApi()
          break
      }
    },
    handleCourse(type) {
      console.log('type:', type)
      switch (type) {
        case 'student':
          this.getAccessWarnApi()
          break
        case 'assign':
          this.getAssignWarnApi()
          break
        case 'quiz':
          this.getQuizWarnApi()
          break
        case 'forum':
          this.getForumWarnApi()
          break
        case 'nopass':
          this.getGradeWarnApi()
          break
      }
    },
    viewAdvice(val) {
      console.log('查看建议', val)
      switch (val.item) {
        case '课程封面':
        case '课程简介':
        case '课程时间':
          window.open(domainName + '/course/edit.php?id=' + this.courseId, '_blank')
          break
        case '课程活动':
        case '课程资源':
          window.open(domainName + '/course/view.php?id=' + this.courseId, '_blank')
          break
        case '尚未批阅的作业':
          window.open(domainName + '/mod/assign/view.php?id=' + val.cmid, '_blank')
          break
        case '尚未批阅的测验':
          window.open(domainName + '/mod/quiz/view.php?id=' + val.cmid, '_blank')
          break
        case '成绩册':
          window.open(domainName + '/grade/edit/tree/index.php?id=' + this.courseId, '_blank')
          break
      }
    },
    exportTable(type, tableId) {
      //导出名称
      let typeName = '作业完成异常'
      switch (type) {
        case 'assign':
          break
        case 'quiz':
          typeName = '测验完成异常'
          break
        case 'forum':
          typeName = '讨论参与异常'
          break
        case 'nopass':
          typeName = '不及格预警'
          break
      }
      let excelName = typeName + '统计' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(
        document.querySelector('#' + tableId),
        xlsxParam
      )
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(
          new Blob([table_write], { type: 'application/octet-stream' }),
          excelName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
}
</script>
<style lang="scss" scoped>
.abnormal-warn {
  ::v-deep {
    .el-tabs--left {
      padding: 0 10px;
      .el-tabs__header.is-left {
        width: 250px;
      }
      .el-tabs__active-bar.is-left {
        height: 0 !important;
      }
      .el-tabs__item.is-left {
        color: #6c757d;
        text-align: left !important;
      }
      .el-tabs__item.is-left.is-active {
        color: #fff;
        background-color: #3294f6;
        border-radius: 4px;
      }
      .el-tabs__nav-wrap.is-left::after {
        height: 0;
      }
    }

    .el-table {
      thead {
        th.el-table__cell {
          background-color: #f5f7fa;
        }
      }
      .cell {
        color: #6c757d;
      }
    }
  }
  .group-condition {
    // margin-left: 12px;
  }
  .data-range {
    font-size: 14px;
    color: #6c757d;
  }
}
.operative {
  color: #409eff;
  margin-right: 1rem;
  cursor: pointer;
}
.export-btn {
  margin-right: 12px;
}
.empty-suggesstion-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .suggesstion-tips {
    margin-top: 37px;
    font-size: 18px;
    color: #98a6ad;
    line-height: 18px;
  }
}
</style>
